export const defaultValues = {
    employee_name: '',
    employee_phone_number: '',
    employee_birthday: null,
    employee_birthplace: '',
    employee_gender: 'male',
    employee_marriage: 'single',
    employee_email: '',
    employee_idno: '',
    employee_idno_issued_on: null,
    employee_idno_issued_by:
        'Cục Cảnh sát quản lý hành chính về trật tự xã hội',
    employee_original_place: '',
    employee_nationality: 'VN', // quốc tịch
    employee_religion: 'Không', // tôn giáo
    employee_nation: 'Kinh', // dân tộc
    employee_country: 'VN',
    employee_city: 'SG',
    employee_district: '',
    employee_ward: '',
    employee_street: '',
    employee_university: '',
    employee_major: '',
    employee_health_insurance: '',
    employee_social_insurance: '',
    employee_medical_registration_place: '',
    employee_temporary_city: '',
    employee_temporary_district: '',
    employee_temporary_ward: '',
    employee_temporary_street: '',
    employee_bank_number: '',
    employee_bank_name: 'Techcombank',
    employee_bank_branch: '',
    employee_personal_tax_code: '',
    employee_experience: '',
    employee_code: '',
    department_id: 0,
    position_id: 0,
    documents: [
        { document_type: 'front_of_cccd', attachments: [] },
        { document_type: 'back_of_cccd', attachments: [] },
    ],
    contact_homies: [
        {
            contact_name: '',
            contact_phone: '',
            contact_relationship: '',
        },
    ],
    attendances: [
        {
            name: '',
            description: '',
        },
    ],
}
